import { monthsAndFestivalWeeks, monthsAndFestivalWeeksPerYear } from './Constants.js';
export function isValidDay(value) {
    return Number.isInteger(value) && value >= 0 && value < 368;
}
export function assertValidDay(value) {
    if (!isValidDay(value)) {
        throw new Error(`Expected a valid day of the year, but received: ${value}. Must be an integer on [0, 367].`);
    }
}
export function doesMonthContainDay(day, monthOrFestivalWeek) {
    assertValidDay(day);
    return (day >= monthOrFestivalWeek.startDay &&
        day < monthOrFestivalWeek.startDay + monthOrFestivalWeek.dayCount);
}
export function doesMonthContainDate(month, date) {
    return month.year === date.year && doesMonthContainDay(date.day, month);
}
export function getMonthFromDay(day) {
    assertValidDay(day);
    for (let i = 0; i < monthsAndFestivalWeeksPerYear; i++) {
        const currentMonthOrFestivalWeek = monthsAndFestivalWeeks[i];
        if (doesMonthContainDay(day, currentMonthOrFestivalWeek)) {
            return currentMonthOrFestivalWeek;
        }
    }
    throw new Error(`Specified day "${day}" is out of year range. This should have been caught above.`);
}
export function getMonthFromDate(date) {
    const monthOrFestivalWeek = getMonthFromDay(date.day);
    return {
        ...monthOrFestivalWeek,
        year: date.year,
    };
}
export function getNextMonth(month) {
    const index = monthsAndFestivalWeeks.findIndex((current) => current.name === month.name);
    if (index < 0) {
        throw new Error(`Provided month "${month.name}" is not a valid month or festival week.`);
    }
    const nextIndex = index + 1;
    if (nextIndex === monthsAndFestivalWeeksPerYear) {
        return {
            ...monthsAndFestivalWeeks[0],
            year: month.year + 1,
        };
    }
    return {
        ...monthsAndFestivalWeeks[nextIndex],
        year: month.year,
    };
}
export function getPreviousMonth(month) {
    const index = monthsAndFestivalWeeks.findIndex((current) => current.name === month.name);
    if (index < 0) {
        throw new Error(`Provided month "${month.name}" is not a valid month or festival week.`);
    }
    const previousIndex = index - 1;
    if (previousIndex < 0) {
        return {
            ...monthsAndFestivalWeeks[monthsAndFestivalWeeksPerYear - 1],
            year: month.year - 1,
        };
    }
    return {
        ...monthsAndFestivalWeeks[previousIndex],
        year: month.year,
    };
}
//# sourceMappingURL=Utilities.js.map